export const customFormResponseStatus = {
    IN_PROGRESS: 1,
    COMPLETE: 2
}

export const customFormResponseStatusList = [
    { id: customFormResponseStatus.IN_PROGRESS, name: "In Progress" },
    { id: customFormResponseStatus.COMPLETE, name: "Complete" }
]